import React, { useState, useRef } from "react";
import { ForgotIcon } from "helper/constant";
import AdminServices from "../../../api/AdminServices";
import Toaster from "../../../components/common/Toaster";
import { withRouter } from "react-router-dom";
import ResetPassword from "./ResetPassword";
import Button from "../../../components/button/Button";
import EncryptDecrypt from "../../../api/EncryptDecrypt";

const Otp = props => {
  const loginContainer = {
    //backgroundImage: `url(${loginBack})`,
    backgroundPosition: "center center",
    backgroundSize: "cover",
    position: "fixed",
    overflow: "auto",
    top: 0,
    bottom: 0,
    backgroundColor: "#AECE38"
  };

  const toaster = useRef();
  const [otp, setOtp] = useState();
  const [view, setView] = useState(true);
  const [loading, setloading] = useState(false);

  function submitHandler(e) {
    e.preventDefault();
    const params = {
      otp: otp,
      otp_token: props && props.otp_token,
      email: props && props.email
    };
    setloading(true);
    AdminServices.otp(params)
      .then(res => {
        let data = EncryptDecrypt.decrypt(res.data);
        if (data.status) {
          if (toaster.current) toaster.current.success(data.message);
          setTimeout(() => {
            setView(false);
            setloading(false);
            // props.history.push("./otp");
          }, 500);
        } else {
          if (toaster.current) toaster.current.error(data.message);
          setloading(false);
        }
      })
      .catch(err => {
        if (toaster.current) toaster.current.error(err.response);
        setloading(false);
      });
  }

  return view ? (
    <div className="container-fluid" style={loginContainer}>
      <div className="form-container">
        <div className="login-icon">
          <img src={ForgotIcon} alt="icon" height="100px" />
        </div>
        <div className="login-title">Enter Otp</div>
        <div className="text-center form-info-text plr-24 mt-16">
          Otp has been provided to your email id
        </div>
        <form className="pa-24" onSubmit={e => submitHandler(e)}>
          <div className="form-group">
            <input
              type="text"
              required
              onChange={e => {
                setOtp(e.target.value);
              }}
              className="form-control react-form-input"
              id="exampleInputEmail1"
              aria-describedby="emailHelp"
              placeholder="Enter Otp"
            />
          </div>
          <Button
            type="submit"
            loading={loading}
            className="btn form-button"
            dataStyle="expand-right"
            style={{ position: "relative" }}
          >
            Verify OTP
          </Button>
        </form>
      </div>
      <Toaster ref={toaster} />
    </div>
  ) : (
    <ResetPassword email={props.email} otp_token={props.otp_token} otp={otp} />
  );
};

export default withRouter(Otp);
